import { render, staticRenderFns } from "./modalInformacion.vue?vue&type=template&id=0f60ef1f&scoped=true"
import script from "./modalInformacion.vue?vue&type=script&lang=js"
export * from "./modalInformacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f60ef1f",
  null
  
)

export default component.exports